import { ACTIVE_ITEMS } from '@constants/activeItems';
import { FormControl, InputLabel, Select } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { MenuItem } from 'components/styled/SelectMenuItem';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

export const OperationField: FC<{
  value: number | null;
  onChange: (value: number | null) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation('reservation');

  const {
    HotelApi: {
      settings: {
        financial: {
          cashRegister: { getAllOperationTypes },
        },
      },
    },
  } = useContext(RootContext);

  const { isLoading, isError, data, refetch } = useQuery({
    queryKey: ['get-cash-registers'],
    queryFn: () => {
      return getAllOperationTypes({
        search: [ACTIVE_ITEMS],
      });
    },
  });

  if (isLoading) {
    return <>...</>;
  }

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel id="reservation-filter-operation-types">Operation</InputLabel>
      <Select
        labelId="reservation-filter-operation-types"
        value={value || ''}
        onChange={event => onChange(Number(event.target.value))}
      >
        <MenuItem firstItem value="all">
          {t('list.filter.all')}
        </MenuItem>
        {(data?.operations || [])?.map((operation, key) => (
          <MenuItem key={`operation-key-${key}`} value={operation.id!}>
            {operation?.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
